function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-CO2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "pollution-co2-message",
  transform: "translate(1.000000, 1.000000)",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4210526,8.36184211 C9.1683122,8.36184211 7.34210526,10.188049 7.34210526,12.4407895 L7.34210526,14.4802632 C7.34210526,16.7330036 9.1683122,18.5592105 11.4210526,18.5592105",
  id: "Path",
  stroke: "#425CD4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5197368,8.36184211 C15.3933666,8.36184211 14.4802632,9.27494558 14.4802632,10.4013158 L14.4802632,16.5197368 C14.4802632,17.6461071 15.3933666,18.5592105 16.5197368,18.5592105 C17.6461071,18.5592105 18.5592105,17.6461071 18.5592105,16.5197368 L18.5592105,10.4013158 C18.5592105,9.27494558 17.6461071,8.36184211 16.5197368,8.36184211 Z",
  id: "Path",
  stroke: "#425CD4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.6184211,16.0098684 C21.6184211,15.1650908 22.3032487,14.4802632 23.1480263,14.4802632 L23.1480263,14.4802632 C23.992804,14.4802632 24.6776316,15.1650908 24.6776316,16.0098684 L24.6776316,16.0098684 C24.6767691,16.5039925 24.5085488,16.9832528 24.2003947,17.3695175 L21.6184211,20.5986842 L24.6776316,20.5986842",
  id: "Path",
  stroke: "#425CD4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5197368,0.203919441 C11.3385606,0.196476812 6.56123509,3.00065887 4.041961,7.5281196 C1.52268691,12.0555803 1.65813928,17.5934435 4.39574561,21.9923246 L0.203947368,30.7960526 L9.00767544,26.6028947 C14.1556081,29.8048607 20.7644138,29.4063077 25.4902391,25.6088912 C30.2160645,21.8114747 32.0281396,15.4434656 30.00961,9.72688136 C27.9910804,4.01029713 22.5822161,0.192006412 16.5197368,0.203919441 L16.5197368,0.203919441 Z",
  id: "Path",
  stroke: "#485156"
})));
function SvgCo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "33px",
    viewBox: "0 0 34 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / CO2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo2);
export default __webpack_public_path__ + "static/media/co2.31666885aa35034b47a7b66feee3e9c1.svg";
export { ForwardRef as ReactComponent };